const labelOffsetX = 90;

// Mui default styles used when shrink
const MuiShrinkLabelOffsetY = -9;
const MuiShrinkLabelScale = 0.75;

// Mui default styles used when not shrink
const MuiLabelOffsetX = 14;
const MuiLabelOffsetY = 16;
const MuiLabelOffsetYSmall = 9;
const MuiLabelScale = 1;

const formats = ["US", "INTL"] as const;

export { labelOffsetX, MuiLabelOffsetX, MuiShrinkLabelOffsetY, MuiShrinkLabelScale, MuiLabelOffsetY, MuiLabelScale, MuiLabelOffsetYSmall, formats };
